<ion-header>
  <ion-toolbar color="light">
    <ion-row class='font1_5'>
      <ion-col size="1" [sizeMd]="showBack?0.5:0" style="display: flex; align-items: center;" *ngIf="showBack">
        <!-- <ion-icon name="menu" *ngIf="showMenu" (click)='menuCtrl.open()'></ion-icon> -->
        <ion-icon name="arrow-back" (click)='location.back()'></ion-icon>
      </ion-col>
      <ion-col [size]="saveButton?8:9" [sizeMd]="showBack?9.5:10" style="padding-top: 8px;" class="singleLine">
        {{label}}
      </ion-col>
      <ion-col size="3" sizeMd="2" class="textRight" *ngIf="saveButton">
        <ion-button (click)="clicked()" size="small" *ngIf="saveButton" color="secondary">
          {{saveButton}}
        </ion-button>
        <!-- <ion-icon name="checkmark-done-circle" color="success" (click)="clicked()" class="font1_5"></ion-icon>
        <ion-icon name="at-circle" color="danger" (click)="clicked()" class="font1_5"></ion-icon> -->
      </ion-col>
      <!-- <ion-col size="3" sizeMd="1" class="textRight"  style="display: flex; align-items: center;"  *ngIf="showProfile"> -->
      <!-- <ion-icon *ngIf="platform.width()<platform.height() && settingIcon" name="ellipsis-vertical"
          class='floatRight'></ion-icon> -->
      <!-- <ion-icon *ngIf="platform.width()<platform.height() && searchIcon" name="search"></ion-icon> -->
      <!-- <app-profile (viewProfile)="viewProfile.emit()"></app-profile> -->

      <!-- </ion-col> -->
      <ion-col size="12">
        <ng-content></ng-content>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-header>